export default "__VITE_ASSET__DtRz4exu__"